import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MessageCircle, Mail, MapPin, Phone } from 'lucide-react';

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const whatsappNumber = '6287886815136';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-brand-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-brand-600 rounded-lg flex items-center justify-center p-1.5">
                <img src="/logo-ipl-removebg.webp" alt="Logo Sistem IPL" className="w-full h-full object-contain" />
              </div>
              <span className="text-xl font-bold">Sistem IPL</span>
            </div>
            <p className="text-white/60 leading-relaxed">
              Platform digital terpercaya untuk mengelola Iuran Pemeliharaan Lingkungan kompleks Anda dengan mudah dan efisien.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Menu</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-white/60 hover:text-white transition-colors">
                  Tentang
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('features')} className="text-white/60 hover:text-white transition-colors">
                  Fitur
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-white/60 hover:text-white transition-colors">
                  Harga
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-white/60 hover:text-white transition-colors">
                  FAQ
                </button>
              </li>
              <li>
                <Link to="/knowledge-center" className="text-white/60 hover:text-white transition-colors">
                  Knowledge Center
                </Link>
              </li>
              <li>
                <Link to="/download" className="text-gold-400 hover:text-gold-300 font-medium transition-colors inline-flex items-center gap-1.5">
                  Download APK
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Kontak</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-white/60">
                <Phone className="flex-shrink-0 mt-1" size={18} />
                <span>0878-8681-5136</span>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <Mail className="flex-shrink-0 mt-1" size={18} />
                <span>info@iplsistem.id</span>
              </li>
              <li className="flex items-start gap-3 text-white/60">
                <MapPin className="flex-shrink-0 mt-1" size={18} />
                <span>Jakarta, Indonesia</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Hubungi Kami</h3>
            <p className="text-white/60 mb-4">
              Punya pertanyaan? Chat langsung dengan tim support kami
            </p>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gold-500 hover:bg-gold-600 text-brand-900 px-6 py-3 rounded-lg font-semibold transition-colors"
            >
              <MessageCircle size={20} />
              Chat WhatsApp
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {new Date().getFullYear()} Sistem IPL. All rights reserved. Dibuat oleh{' '}
              <a
                href="https://nuratech.id"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white underline transition-colors"
              >
                Nuratech
              </a>
            </p>
            <div className="flex gap-6 text-sm text-white/50">
              <Link to="/kebijakan-privasi" className="hover:text-white transition-colors">Kebijakan Privasi</Link>
              <Link to="/syarat-ketentuan" className="hover:text-white transition-colors">Syarat & Ketentuan</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
